import { StyledCell } from '../Table.style';
import styled from 'styled-components';
import _ from 'lodash';
import { getColor } from 'common/constants/_colors';

const StyledTypeChip = styled.div`
  border-radius: 5px;
  padding: 0.2rem 1rem;
  background-color: ${getColor('titanWhite')};
  color: ${getColor('shuttleGray')};
  border: 1px solid ${getColor('shuttleGray')};
  font-size: 1rem;
`;

const mapTypeToUI = {
  reported: 'api integration'
};

const ReleaseDetectionCell = ({ type }) => {
  const typeToView = _.get(mapTypeToUI, type) || type;
  return (
    <StyledCell>
      <StyledTypeChip>{_.startCase(typeToView)}</StyledTypeChip>
    </StyledCell>
  );
};

export default ReleaseDetectionCell;
